import { FormFieldTypes } from "../../../../../../../data/formFieldType";

export const ProductFormData = {
  name: "SGBSApplicationFormData",

  initialState: {
    brandName: "",
    modalName: "",
  },

  formFields: [
    

    {
      id: "brandName",
      lable: "Brand Name",
      Field_Name: "Brand Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "brandName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        isDisable: false,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-12 mb-3" },
    },
    {
      id: "modalName",
      lable: "Modal Name",
      Field_Name: "Modal Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "modalName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        isDisable: false,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-12 mb-3" },
    },
  ],

  formSetting: {
    isViewOnly: false,
  },
};
